/* Built In Imports */
import NextLink from 'next/link';
import { useRouter } from 'next/router';

/* External Imports */
import { Box, Link } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */
// import StructuredTextContent from '@components/UI/StructuredTextContent';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import { refineUrlDomain } from '@components/Utility/utils';
import { Styles } from '../../constants';

/* Services */

/**
 * Renders the Card Info 2 Card component
 *
 * @param {string} region - region for section
 * @param {string} lang - lang for section
 * @param {object} sectionContent - Data for section
 * @param {string} region - Region of the page
 * @param {string} lang - Language of the page
 * @returns {ReactElement} Card Info2 Card component
 */

const CardInfo2 = ({ pageConfig, sectionContent, region, lang }) => {
  const pName = pageConfig?.pageName;
  // console.log("the page name is", pName)
  const bgColors = Styles.bgColors;
  const router = useRouter();
  const isSannidhiBengaluruPage = router.asPath.includes('welcome-to-sadhguru-sannidhi-bengaluru');

  // console.log("the section content is", sectionContent);

  // const redirect = url => {
  //   window.scrollTo(0, 0);
  //   router.push(url).catch(err => console.log(err));
  // };

  const cardCount = sectionContent?.cards?.length || 0;
  
  return (
    <Box
      display={cardCount >= 2 ? "grid" : "flex"}
      gridTemplateColumns={cardCount >= 2 ? { base: "1fr", md: "1fr 1fr" } : "none"}
      w="full"
      flexWrap="wrap"
      gridGap={{ base: "20px", md: "30px" }}
      gridRowGap={{ base: "40px", md: "60px" }}
      justifyContent="center"
      mx="auto"
      maxW={cardCount >= 2 ? { base: "100%", md: "800px" } : "370px"}
    >
      {sectionContent?.cards?.map((secCon, index) => {
        return (
          <Box
            key={nanoid()}
            w={{ base: '100%', md: '370px' }}
            maxW="370px"
            justifyContent="center"
            mx={pName === 'hytt' ? '0px' : 'auto'}
          >
            <NextLink
              href={refineUrlDomain(secCon.buttonLink, region, lang)}
              passHref
              legacyBehavior
            >
              <Link
                cursor={secCon.buttonLink ? 'cursor' : 'auto'}
                position="relative"
                display="block"
                _after={{
                  content: '" "',
                  w: { base: '82%', md: '82%' },
                  h: { base: '220px', md: '250px' },
                  objectFit: 'contain',
                  transform: 'rotate(-178.76deg)',
                  position: 'absolute',
                  background: bgColors[0],
                  outline: '1px solid transparent',
                  zIndex: '-1',
                  top: { base: '-10px', md: '-10px' },
                  left: {base:"8.5%", md:'3%'}
                }}
              >
                <LazyLoadImageComponent
                  // onClick={() =>
                  //   redirect(refineUrlDomain(secCon.buttonLink, region, lang))
                  // }
                  src={secCon.thumbnail?.url}
                  alt={secCon.thumbnail?.alt}
                  title={secCon.thumbnail?.title}
                  h={{ base: '200px', md: '230px' }}
                  objectFit="contain"
                  w="full"
                  maxW="370px"
                  mx="auto"
                />
              </Link>
            </NextLink>

            <Box
              width="90%"
              mx="auto"
              marginTop="30px"
              paddingLeft={{ base: isSannidhiBengaluruPage ? '10px' : '0'}}
              textAlign={pName === 'hytt' && 'center'}
            >
              <Box
                as="span"
                fontFamily="FedraSansStd-A-medium"
                fontSize="22px"
                color="#28231E"
                pt={'12px'}
                mt="35px"
                fontWeight="500"
              >
                {secCon.title}
              </Box>
              <Box
                fontFamily="FedraSansStd-book"
                fontSize="16px"
                color="{'gray.200'}"
                pt={'12px'}
                className="sadhguru-mystic"
              >
                <style global jsx>
                  {`
                    .sadhguru-mystic a {
                      color: #cf4520 !important;
                      border-bottom: 1px solid #cf4520 !important;
                      transition: 0.2s linear;
                    }
                    .sadhguru-mystic a:hover {
                      background: #cf4520 !important;
                      color: #fff !important;
                    }
                  `}
                </style>
                <StructuredTextParser
                  textAlign={pName === 'hytt' && 'center'}
                  str={render(secCon.description)}
                  region={region}
                  lang={lang}
                  mt="0"
                />
                <style global jsx>
                  {`
                    .sadhguru-mystic p {
                      margin-bottom: 12px;
                    }
                  `}
                </style>
              </Box>
              <Box display="flex" justifyContent="space-between">
                {secCon.buttonLink && secCon.buttonText && (
                  <NextLink
                    href={refineUrlDomain(secCon.buttonLink, region, lang)}
                    // onClick={() =>
                    //   redirect(refineUrlDomain(secCon.buttonLink, region, lang))
                    // }
                    passHref
                    legacyBehavior
                  >
                    <Link
                      bgColor="transparent"
                      color="#cf4520"
                      mr={{ base: '0', md: '20px' }}
                      padding={{base: isSannidhiBengaluruPage ? '13px 50px' : '5px 30px', md:'5px 30px'}}
                      border="1px solid #cf4520"
                      borderRadius="5px"
                      display="inline-block"
                      mb="20px"
                      mt={['12px', '12px', '12px', '24px']}
                      fontFamily="FedraSansStd-medium"
                      fontSize={{ base: isSannidhiBengaluruPage ? '16px' : "13px", md:'13px'}}
                      _hover={{
                        color: '#fff',
                        bgColor: '#cf4520',
                        textDecoration: 'none',
                      }}
                      _focus={{
                        color: '#fff',
                        bgColor: '#cf4520',
                        textDecoration: 'none',
                      }}
                      _active={{
                        color: '#fff',
                        bgColor: '#cf4520',
                        textDecoration: 'none',
                      }}
                    >
                      {secCon.buttonText}
                    </Link>
                  </NextLink>
                )}
              </Box>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default CardInfo2;
